module.exports = __webpack_public_path__ + "img/group25@2x-zh.f1079276.png";